import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import Inquiry from "./sections/Inquiry";
import Headquarters from "./sections/Headquarters";
import Channels from "./sections/Channels";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <Inquiry />
      <Headquarters />
      <Channels />
      <Footer />
    </div>;
}